// Ruta relativa (mismo origen): nginx ya reenvía /api/* al middleapi correcto
// de cada entorno (services/nginx/templates/default.conf.template, DOCKER_API_IP/
// DOCKER_API_PORT sustituidos al arrancar el contenedor, no al compilar). Un único
// build del frontend sirve para cualquier entorno; en local (`npm start`, sin
// nginx delante) lo resuelve el proxy de desarrollo de CRA (ver "proxy" en
// package.json).
export function getUrl() {
  return '/api';
}

export function sessionExpired(reqStatus) {
  let unautorized = false;
  if (reqStatus === 401) {
    unautorized = true;
    console.log('Session expired! Status 401! Redirect to login...');
    window.location.replace('/login');
    // window.location.href = '/login';
  }
  return unautorized;
}
